<template>
  <div class="mt-5 container">
    <h1>Hive Services</h1>
    <v-row class="mt-10">
      <v-col cols="12" md="4">
        <v-img src="/img/services/idea.jpg"> </v-img>
      </v-col>
      <v-col cols="12" md="8" class="d-flex align-center">
        <div>
          <h2>Product Strategy</h2>
          <p>
            <strong> An idea's value is in the details! </strong> We help you
            and your team solidify a well-thought-out plan describing what your
            product hopes to accomplish and how it plans to do so.
          </p>
        </div>
      </v-col>
    </v-row>

    <v-row class="flex-md-row-reverse">
      <v-col cols="12" md="4">
        <v-img src="/img/services/ux.jpg"> </v-img>
      </v-col>
      <v-col cols="12" md="8" class="d-flex align-center">
        <div>
          <h2>User Experience</h2>
          <p>
            <strong>
              We start with the customer experience and work backwards to the
              technology
            </strong>
            Our user experience team will work with you and your customers to
            ensure your product is easy and pleasing to use
          </p>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <v-img src="/img/services/design.jpg"> </v-img>
      </v-col>
      <v-col cols="12" md="8" class="d-flex align-center">
        <div>
          <h2>User Interface Design</h2>
          <p>
            UI design is not only how something looks but how a user
            <strong>feels</strong> when using your product. At Hive, we create
            appropriate and meaningful designs that help connect your customers
            to your product.
          </p>
        </div>
      </v-col>
    </v-row>
    <v-row class="flex-md-row-reverse">
      <v-col cols="12" md="4">
        <v-img src="/img/services/diagram.png"> </v-img>
      </v-col>
      <v-col cols="12" md="8" class="d-flex align-center">
        <div>
          <h2>Application Architecture</h2>
          <p>
            We provide our clients with a detailed application architecture plan
            and documentation. The architecture gives you a roadmap and best
            practices to follow when building an application so that you end up
            with a well-structured app.
          </p>
        </div>
      </v-col>
    </v-row>
    <v-row class="">
      <v-col cols="12" md="4">
        <v-img src="/img/services/code.jpg"> </v-img>
      </v-col>
      <v-col cols="12" md="8" class="d-flex align-center">
        <div>
          <h2>Application Development</h2>
          <p>
            <strong> Ideas are worth nothing unless executed. </strong>
            We see everything through to the end! We take all that we have
            learned and designed and put it to the test by building products
            iteratively and refining them with new ideas and end-user feedback.
          </p>
        </div>
      </v-col>
    </v-row>
    <v-divider> </v-divider>
    <v-row class="contact-us" ref="applyform" id="applyform">
      <v-col cols="12" class="pa-9 mt-1 text-center">
        <div class="mx-auto form-wrapper">
          <div class="mb-2">
            <h2>Contact Us</h2>
            <div>We would love to chat about your Startup!</div>
          </div>
          <ConvertKitForm v-bind="config" />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<style lang="scss" scoped>
.form-wrapper {
  max-width: 600px;
  margin: auto;
}
</style>

<script>
import ConvertKitForm from "convertkit-vue";

export default {
  name: "Services",
  components: { ConvertKitForm },
  data() {
    return {
      thanksDialog: false,
      config: {
        formId: 5835784,
        template: "clare",
        emailPlaceholder: "Enter an email address",
        submitText: "Contact Us",
        namePlaceholder: "Name",
      },
    };
  },
};
</script>
